import React, { useState } from 'react';
import { formatMoney, formatNumber } from '../../../../utils/utils';
import { Button, Collapse } from 'react-bootstrap';
import { WarehouseOrderItemShowDataForm } from '../../../../app/models/WarehouseOrderItem';

interface Props {
    warehouseOrderItemShowForm: WarehouseOrderItemShowDataForm;
}

const WarehouseOrderItemShowForm = ({ warehouseOrderItemShowForm }: Props) => {
    const [openRates, setOpenRates] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);

    if (!warehouseOrderItemShowForm) return null;

    return (
        <>
          {/* Servicio adicional */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Servicio</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={warehouseOrderItemShowForm.service || ''}
            disabled
          />
        </div>
      </div>

      {/* Producto */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Producto</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={warehouseOrderItemShowForm.product}
            disabled
          />
        </div>
      </div>

      {/* Fecha Cuota */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Fecha Cuota</label>
        <div className="col-md-9">
          <input
            type="date"
            className="form-control"
            value={warehouseOrderItemShowForm.quota_date || ''}
            disabled
          />
        </div>
      </div>

      {/* Cantidad y unidad */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Cantidad</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-6">
              <input
                type="number"
                className="form-control"
                value={warehouseOrderItemShowForm.quantity ?? ''}
                disabled
              />
            </div>
            <div className="col-6">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.quantity_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Almacén */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Almacén</label>
        <div className="col-md-9">
          <input
            type="text"
            className="form-control"
            value={warehouseOrderItemShowForm.depot}
            disabled
          />
        </div>
      </div>

      {/* Precio Unitario Venta */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Precio Unitario Venta</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-4">
              <input
                type="number"
                className="form-control"
                value={warehouseOrderItemShowForm.unit_price ?? ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.currency || ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.rate_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Datos de Almacenamiento y Tarifas */}
      {/* Días libres */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Días libres</label>
        <div className="col-md-9">
          <input
            type="number"
            className="form-control"
            value={warehouseOrderItemShowForm.free_days ?? ''}
            disabled
          />
        </div>
      </div>

      {/* Tarifa por ingreso (fijo) */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por ingreso (fijo)</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-4">
              <input
                type="number"
                className="form-control"
                value={warehouseOrderItemShowForm.container_entry_fee ?? ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.container_entry_fee_currency || ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.container_entry_fee_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tarifa por día almacenaje */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por día almacenaje</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-4">
              <input
                type="number"
                className="form-control"
                value={warehouseOrderItemShowForm.daily_storage_fee ?? ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.daily_storage_fee_currency || ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.daily_storage_fee_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Tarifa por salida (fijo) */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Tarifa por salida (fijo)</label>
        <div className="col-md-9">
          <div className="row g-1">
            <div className="col-4">
              <input
                type="number"
                className="form-control"
                value={warehouseOrderItemShowForm.container_exit_fee ?? ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.container_exit_fee_currency || ''}
                disabled
              />
            </div>
            <div className="col-4">
              <input
                type="text"
                className="form-control"
                value={warehouseOrderItemShowForm.container_exit_fee_unit || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>

      {/* Comentarios */}
      <div className="mb-2 row">
        <label className="col-md-3 col-form-label">Comentarios</label>
        <div className="col-md-9">
          <textarea
            className="form-control"
            value={warehouseOrderItemShowForm.comment || ''}
            disabled
          />
        </div>
      </div>
    </>
    );
};

export default WarehouseOrderItemShowForm;
